module.exports = __webpack_public_path__ + "media/images/Client-hover-7eef8a5550cd041ddccf936f0c8d40c2.png";